import React from 'react';
import './Dashboard.css';

interface KpiCardProps {
  title: string;
  value: string | number;
  icon: string; // Ex: '📦' ou '🚀'
}

export const KpiCard: React.FC<KpiCardProps> = ({ title, value, icon }) => {
  return (
    <div className="kpi-card">
      <div className="kpi-icon">{icon}</div>
      <div className="kpi-content">
        <div className="kpi-value">{value}</div>
        <div className="kpi-title">{title}</div>
      </div>
    </div>
  );
};